import { render, staticRenderFns } from "./CreateAddress.vue?vue&type=template&id=ba779a8e&scoped=true"
import script from "./CreateAddress.vue?vue&type=script&lang=js"
export * from "./CreateAddress.vue?vue&type=script&lang=js"
import style0 from "./CreateAddress.vue?vue&type=style&index=0&id=ba779a8e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba779a8e",
  null
  
)

export default component.exports